import { TrashIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from '@/components/core/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/core/tooltip';

type RowActionBarProps = {
  isSaving: boolean;
  isDeleting: boolean;
  submitLabel?: ReactNode;
  onCancel: () => void;
  onSubmit: () => void;
  onDelete?: () => void;
};

export function RowActionBar({
  isSaving,
  isDeleting,
  submitLabel = 'Save',
  onCancel,
  onSubmit,
  onDelete,
}: RowActionBarProps) {
  const isPending = isSaving || isDeleting;

  return (
    <div className="flex shrink-0 items-center gap-1.5">
      {onDelete && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon-xs"
              loading={isDeleting}
              disabled={isPending}
              aria-label="Delete row"
              className="text-destructive hover:text-destructive"
              onClick={onDelete}
            >
              <TrashIcon className="size-3.5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Delete row</TooltipContent>
        </Tooltip>
      )}
      <Button type="button" variant="outline" size="xs" disabled={isPending} onClick={onCancel}>
        Cancel
      </Button>
      <Button type="button" size="xs" loading={isSaving} disabled={isPending} onClick={onSubmit}>
        {submitLabel}
      </Button>
    </div>
  );
}
